import VideoBlock from './VideoBlock'
Vue.component('VideoBlock', VideoBlock)



// WEBPACK FOOTER //
// ./src/js/components/VideoBlock/index.js